import React from 'react'
import useAnalyticsContext from 'src/analytics/useAnalyticsContext'
import * as style from 'src/app/CardFeedDetails/components/CardSelectionSnackbar.style'
import SvgClose from 'src/components/Svgs/SvgClose'
import PluralTrns from 'src/localization/PluralTrns'
import { useTranslate } from 'src/localization/Trns'

export interface CardSelectionSnackbarProps {
  selectedCount: number
  onAssign: () => void
  onClose: () => void
}

const CardSelectionSnackbar: React.FC<CardSelectionSnackbarProps> = ({
  selectedCount,
  onAssign,
  onClose,
}) => {
  const translate = useTranslate()
  const { analytics } = useAnalyticsContext()

  if (selectedCount === 0) return null

  const handleAssignClick = (): void => {
    analytics.track('card feed details', { action: 'assign all clicked' })
    onAssign()
  }

  return (
    <div
      role="region"
      aria-label={translate('Selected cards actions')}
      css={style.container}
      data-testid="card-feed-cards-selection-snackbar"
    >
      {/*
        Live region so assistive tech announces the count as the user toggles
        selections (SC 4.1.3 — Status Messages). role="status" implies
        aria-live="polite" and aria-atomic="true"; declaring both explicitly
        documents intent for future readers.
      */}
      <span
        role="status"
        aria-live="polite"
        aria-atomic="true"
        css={style.count}
        data-testid="card-feed-cards-selection-count"
      >
        <PluralTrns
          singleSource={'1 card selected'}
          pluralSource={'${count} cards selected'}
          count={selectedCount}
        />
      </span>
      <span css={style.divider} aria-hidden="true" />
      <button
        type="button"
        css={style.assignButton}
        onClick={handleAssignClick}
        data-testid="card-feed-cards-selection-assign"
      >
        {translate('Assign Account Owner')}
      </button>
      <span css={style.divider} aria-hidden="true" />
      <button
        type="button"
        css={style.closeButton}
        onClick={onClose}
        aria-label={translate('Clear selection')}
        data-testid="card-feed-cards-selection-close"
      >
        <SvgClose
          width={20}
          height={20}
          viewBox="0 0 25 25"
          stroke="currentColor"
        />
      </button>
    </div>
  )
}

export default CardSelectionSnackbar
